import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './utility-nav.styles';

/**
 * @slot default - The utility nav items
 * @csspart base - The component's base wrapper.
 * @csspart link - The component's link wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksUtilityNav extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Aria label attribute
   * - Provides an accessible name for the nav element
   */
  @property({ type: String })
  arialabel: string | undefined;

  /**
   * Provides an option for utility nav item to use 100% available space
   */
  @property({ type: Boolean })
  fullWidth = false;

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-c-utility-nav', {
      'cat-c-utility-nav--full-width': this.fullWidth === true
    });

    return html`
      <nav part="base" class="${componentClassName}" aria-label=${this.arialabel ? this.arialabel : 'Utility nav'}>
        <ul part="link" role="menubar" class="cat-c-utility-nav__list">
          <slot part="part-default"></slot>
        </ul>
      </nav>
    `;
  }
}

if (customElements.get('cat-utility-nav') === undefined) {
  customElements.define('cat-utility-nav', BlocksUtilityNav);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-utility-nav': BlocksUtilityNav;
  }
}
